import * as React from "react";

import { cn } from "lib/utils";

import { MODAL_GUTTER_WIDTH_CLASS } from "./modal-styles";
import { DialogContent } from "./dialog";

type ResponsiveDialogSize = "sm" | "md" | "lg" | "xl";

const SIZE_CLASSES: Record<ResponsiveDialogSize, string> = {
  sm: "max-w-md",
  md: "max-w-2xl",
  lg: "max-w-3xl",
  xl: "max-w-4xl",
};

interface ResponsiveDialogContentProps
  extends React.ComponentPropsWithoutRef<typeof DialogContent> {
  size?: ResponsiveDialogSize;
}

export const ResponsiveDialogContent = React.forwardRef<
  React.ElementRef<typeof DialogContent>,
  ResponsiveDialogContentProps
>(({ className, size = "md", ...props }, ref) => (
  <DialogContent
    ref={ref}
    className={cn(
      MODAL_GUTTER_WIDTH_CLASS,
      "max-h-[calc(100dvh-1rem)] overflow-y-auto p-4 sm:p-6",
      SIZE_CLASSES[size],
      className,
    )}
    {...props}
  />
));

ResponsiveDialogContent.displayName = "ResponsiveDialogContent";
